import React from "react";
import NewPOSPrime from "./NewPOSPrime";

import { HandleInvoiceStateProvider } from "./Components/HandleInvoiceStateProvider";

function CreatePos() {
  return (
    <HandleInvoiceStateProvider>
      <NewPOSPrime/>
    </HandleInvoiceStateProvider>
  );
}

export default CreatePos;
